import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export function useLogo() {
  const [url, setUrl] = useState(null);
  const [loaded, setLoaded] = useState(false);

  const load = () => {
    api.get("/settings/logo", { responseType: "blob" })
      .then((r) => setUrl((old) => { if (old) URL.revokeObjectURL(old); return URL.createObjectURL(r.data); }))
      .catch(() => setUrl(null))
      .finally(() => setLoaded(true));
  };

  useEffect(() => { load(); }, []);
  return { url, loaded, reload: load };
}
